/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface DeleteRecourseBookingBySupplierId$Params {
  supplierId: string;
}

export function deleteRecourseBookingBySupplierId(
  http: HttpClient,
  rootUrl: string,
  params: DeleteRecourseBookingBySupplierId$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteRecourseBookingBySupplierId.PATH, 'delete');
  if (params) {
    rb.path('supplierId', params.supplierId, {});
  }

  return http.request(rb.build({ responseType: 'text', accept: '*/*', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    }),
  );
}

deleteRecourseBookingBySupplierId.PATH =
  '/service/v1/automatedUiTesting/booking/recourseBookingBySupplierId/{supplierId}';
